(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["clipin-product-template-all-colors"]) return;
  try {
    
  class SectionProductGallery extends HTMLElement {
     constructor() {
         super();
         
         var $container = $(this);

         $container.find('.slider-for').slick({
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows: true,
             dots: false,
             fade: false,
             draggable: false,
             infinite: true,
             asNavFor: '.slider-nav'
         });
         $container.find('.slider-nav').slick({
             slidesToShow: 5,
             slidesToScroll: 5,
             asNavFor: '.slider-for',
             vertical: true,
             verticalSwiping: true,
             dots: false,
             arrows: false,
             infinite: true,
             focusOnSelect: true
         });
     }
  }
  customElements.define('product-gallery', SectionProductGallery);

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('header-sticky-wrap');
      this.headerBounds = {};
      this.currentScrollTop = 0;

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        // requestAnimationFrame(this.hide.bind(this));
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-accessories"]) return;
  try {
    
  class SectionProductGallery extends HTMLElement {
     constructor() {
         super();
         
         var $container = $(this);

         $container.find('.slider-for').slick({
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows: true,
             dots: true,
             fade: false,
             draggable: false,
             infinite: true,
             asNavFor: '.slider-nav'
         });
         $container.find('.slider-nav').slick({
             slidesToShow: 5,
             slidesToScroll: 5,
             asNavFor: '.slider-for',
             vertical: true,
             verticalSwiping: true,
             dots: false,
             arrows: false,
             infinite: true,
             focusOnSelect: true
         });
     }
  }
  customElements.define('product-gallery', SectionProductGallery);

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-gummies"]) return;
  try {
    
  class SectionProductGallery extends HTMLElement {
     constructor() {
         super();
         
         var $container = $(this);

         $container.find('.slider-for').slick({
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows: true,
             dots: true,
             fade: false,
             draggable: false,
             infinite: true,
             asNavFor: '.slider-nav'
         });
         $container.find('.slider-nav').slick({
             slidesToShow: 5,
             slidesToScroll: 5,
             asNavFor: '.slider-for',
             vertical: true,
             verticalSwiping: true,
             dots: false,
             arrows: false,
             infinite: true,
             focusOnSelect: true
         });
     }
  }
  customElements.define('product-gallery', SectionProductGallery);

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-bundle-clip-pony"]) return;
  try {
    
  class SectionProductGallery extends HTMLElement {
     constructor() {
         super();
         
         var $container = $(this);

         $container.find('.slider-for').slick({
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows: true,
             dots: false,
             fade: false,
             draggable: false,
             infinite: true,
             asNavFor: '.slider-nav'
         });
         $container.find('.slider-nav').slick({
             slidesToShow: 5,
             slidesToScroll: 5,
             asNavFor: '.slider-for',
             vertical: true,
             verticalSwiping: true,
             dots: false,
             arrows: false,
             infinite: true,
             focusOnSelect: true
         });
     }
  }
  customElements.define('product-gallery', SectionProductGallery);

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-clip-in"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  class SectionProductGallery extends HTMLElement {
       constructor() {
           super();
           
           var $container = $(this);

           $container.find('.slider-for').slick({
               slidesToShow: 1,
               slidesToScroll: 1,
               arrows: true,
               dots: true,
               fade: false,
               draggable: false,
               infinite: true,
               asNavFor: '.slider-nav'
           });
           $container.find('.slider-nav').slick({
               slidesToShow: 5,
               slidesToScroll: 1,
               asNavFor: '.slider-for',
               vertical: true,
               verticalSwiping: true,
               dots: false,
               arrows: false,
               infinite: true,
               focusOnSelect: true
           });
       }
   }
   customElements.define('product-gallery', SectionProductGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-gift-card"]) return;
  try {
    
  class SectionProductGallery extends HTMLElement {
     constructor() {
         super();
         
         var $container = $(this);

         $container.find('.slider-for').slick({
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows: true,
             dots: false,
             fade: false,
             draggable: false,
             infinite: true,
             asNavFor: '.slider-nav'
         });
         $container.find('.slider-nav').slick({
             slidesToShow: 5,
             slidesToScroll: 5,
             asNavFor: '.slider-for',
             vertical: true,
             verticalSwiping: true,
             dots: false,
             arrows: false,
             infinite: true,
             focusOnSelect: true
         });
     }
  }
  customElements.define('product-gallery', SectionProductGallery);

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-pick-color"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  class SectionProductGallery extends HTMLElement {
       constructor() {
           super();
           
           var $container = $(this);

           $container.find('.slider-for').slick({
               slidesToShow: 1,
               slidesToScroll: 1,
               arrows: true,
               dots: true,
               fade: false,
               draggable: false,
               infinite: true,
               asNavFor: '.slider-nav'
           });
           $container.find('.slider-nav').slick({
               slidesToShow: 5,
               slidesToScroll: 1,
               asNavFor: '.slider-for',
               vertical: true,
               verticalSwiping: true,
               dots: false,
               arrows: false,
               infinite: true,
               focusOnSelect: true
           });
       }
   }
   customElements.define('product-gallery', SectionProductGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-pony"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  class SectionProductGallery extends HTMLElement {
       constructor() {
           super();
           
           var $container = $(this);

           $container.find('.slider-for').slick({
               slidesToShow: 1,
               slidesToScroll: 1,
               arrows: true,
               dots: true,
               fade: false,
               draggable: false,
               infinite: true,
               asNavFor: '.slider-nav'
           });
           $container.find('.slider-nav').slick({
               slidesToShow: 5,
               slidesToScroll: 1,
               asNavFor: '.slider-for',
               vertical: true,
               verticalSwiping: true,
               dots: false,
               arrows: false,
               infinite: true,
               focusOnSelect: true
           });
       }
   }
   customElements.define('product-gallery', SectionProductGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-royal-clip"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  class SectionProductGallery extends HTMLElement {
       constructor() {
           super();
           
           var $container = $(this);

           $container.find('.slider-for').slick({
               slidesToShow: 1,
               slidesToScroll: 1,
               arrows: true,
               dots: true,
               fade: false,
               draggable: false,
               infinite: true,
               asNavFor: '.slider-nav'
           });
           $container.find('.slider-nav').slick({
               slidesToShow: 5,
               slidesToScroll: 1,
               asNavFor: '.slider-for',
               vertical: true,
               verticalSwiping: true,
               dots: false,
               arrows: false,
               infinite: true,
               focusOnSelect: true
           });
       }
   }
   customElements.define('product-gallery', SectionProductGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-tape"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  class SectionProductGallery extends HTMLElement {
       constructor() {
           super();
           
           var $container = $(this);

           $container.find('.slider-for').slick({
               slidesToShow: 1,
               slidesToScroll: 1,
               arrows: true,
               dots: true,
               fade: false,
               draggable: false,
               infinite: true,
               asNavFor: '.slider-nav'
           });
           $container.find('.slider-nav').slick({
               slidesToShow: 5,
               slidesToScroll: 1,
               asNavFor: '.slider-for',
               vertical: true,
               verticalSwiping: true,
               dots: false,
               arrows: false,
               infinite: true,
               focusOnSelect: true
           });
       }
   }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-temp-product-template"]) return;
  try {
    
  class SectionProductGallery extends HTMLElement {
     constructor() {
         super();
         
         var $container = $(this);

         $container.find('.slider-for').slick({
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows: true,
             dots: false,
             fade: false,
             draggable: false,
             infinite: true,
             asNavFor: '.slider-nav'
         });
         $container.find('.slider-nav').slick({
             slidesToShow: 5,
             slidesToScroll: 5,
             asNavFor: '.slider-for',
             vertical: true,
             verticalSwiping: true,
             dots: false,
             arrows: false,
             infinite: true,
             focusOnSelect: true
         });
     }
  }
  customElements.define('product-gallery', SectionProductGallery);

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-temp-wigs"]) return;
  try {
    
  class SectionProductGallery extends HTMLElement {
     constructor() {
         super();
         
         var $container = $(this);

         $container.find('.slider-for').slick({
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows: true,
             dots: false,
             fade: false,
             draggable: false,
             infinite: true,
             asNavFor: '.slider-nav'
         });
         $container.find('.slider-nav').slick({
             slidesToShow: 5,
             slidesToScroll: 5,
             asNavFor: '.slider-for',
             vertical: true,
             verticalSwiping: true,
             dots: false,
             arrows: false,
             infinite: true,
             focusOnSelect: true
         });
     }
  }
  customElements.define('product-gallery', SectionProductGallery);

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-temp-wigs2"]) return;
  try {
    
  class SectionProductGallery extends HTMLElement {
     constructor() {
         super();
         
         var $container = $(this);

         $container.find('.slider-for').slick({
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows: true,
             dots: false,
             fade: false,
             draggable: false,
             infinite: true,
             asNavFor: '.slider-nav'
         });
         $container.find('.slider-nav').slick({
             slidesToShow: 5,
             slidesToScroll: 5,
             asNavFor: '.slider-for',
             vertical: true,
             verticalSwiping: true,
             dots: false,
             arrows: false,
             infinite: true,
             focusOnSelect: true
         });
     }
  }
  customElements.define('product-gallery', SectionProductGallery);

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-template-novid"]) return;
  try {
    
  class SectionProductGallery extends HTMLElement {
     constructor() {
         super();
         
         var $container = $(this);

         $container.find('.slider-for').slick({
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows: true,
             dots: false,
             fade: false,
             draggable: false,
             infinite: true,
             asNavFor: '.slider-nav'
         });
         $container.find('.slider-nav').slick({
             slidesToShow: 5,
             slidesToScroll: 5,
             asNavFor: '.slider-for',
             vertical: true,
             verticalSwiping: true,
             dots: false,
             arrows: false,
             infinite: true,
             focusOnSelect: true
         });
     }
  }
  customElements.define('product-gallery', SectionProductGallery);

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-template-toppers"]) return;
  try {
    
  class SectionProductGallery extends HTMLElement {
     constructor() {
         super();
         
         var $container = $(this);

         $container.find('.slider-for').slick({
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows: true,
             dots: false,
             fade: false,
             draggable: false,
             infinite: true,
             asNavFor: '.slider-nav'
         });
         $container.find('.slider-nav').slick({
             slidesToShow: 5,
             slidesToScroll: 5,
             asNavFor: '.slider-for',
             vertical: true,
             verticalSwiping: true,
             dots: false,
             arrows: false,
             infinite: true,
             focusOnSelect: true
         });
     }
  }
  customElements.define('product-gallery', SectionProductGallery);

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-volumizer"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  class SectionProductGallery extends HTMLElement {
       constructor() {
           super();
           
           var $container = $(this);

           $container.find('.slider-for').slick({
               slidesToShow: 1,
               slidesToScroll: 1,
               arrows: true,
               dots: true,
               fade: false,
               draggable: false,
               infinite: true,
               asNavFor: '.slider-nav'
           });
           $container.find('.slider-nav').slick({
               slidesToShow: 5,
               slidesToScroll: 1,
               asNavFor: '.slider-for',
               vertical: true,
               verticalSwiping: true,
               dots: false,
               arrows: false,
               infinite: true,
               focusOnSelect: true
           });
       }
   }
   customElements.define('product-gallery', SectionProductGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-replacement-tab"]) return;
  try {
    
  class SectionProductGallery extends HTMLElement {
     constructor() {
         super();
         
         var $container = $(this);

         $container.find('.slider-for').slick({
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows: true,
             dots: true,
             fade: false,
             draggable: false,
             infinite: true,
             asNavFor: '.slider-nav'
         });
         $container.find('.slider-nav').slick({
             slidesToShow: 5,
             slidesToScroll: 5,
             asNavFor: '.slider-for',
             vertical: true,
             verticalSwiping: true,
             dots: false,
             arrows: false,
             infinite: true,
             focusOnSelect: true
         });
     }
  }
  customElements.define('product-gallery', SectionProductGallery);

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-starter-clips"]) return;
  try {
    
  class SectionProductGallery extends HTMLElement {
     constructor() {
         super();
         
         var $container = $(this);

         $container.find('.slider-for').slick({
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows: true,
             dots: false,
             fade: false,
             draggable: false,
             infinite: true,
             asNavFor: '.slider-nav'
         });
         $container.find('.slider-nav').slick({
             slidesToShow: 5,
             slidesToScroll: 5,
             asNavFor: '.slider-for',
             vertical: true,
             verticalSwiping: true,
             dots: false,
             arrows: false,
             infinite: true,
             focusOnSelect: true
         });
     }
  }
  customElements.define('product-gallery', SectionProductGallery);

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ponytail-template"]) return;
  try {
    
   class SectionProductGallery extends HTMLElement {
       constructor() {
           super();
           
           var $container = $(this);

           $container.find('.slider-for').slick({
               slidesToShow: 1,
               slidesToScroll: 1,
               arrows: false,
               fade: true,
               draggable: false,
               infinite: false,
               asNavFor: '.slider-nav'
           });
           $container.find('.slider-nav').slick({
               slidesToShow: 5,
               slidesToScroll: 1,
               asNavFor: '.slider-for',
               vertical: true,
               verticalSwiping: true,
               dots: false,
               arrows: false,
               focusOnSelect: true
           });
       }
   }

   customElements.define('product-gallery', SectionProductGallery);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-gallery"] && !window.DesignMode) return;
  try {
    
   class SectionProductGallery extends HTMLElement {
       constructor() {
           super();
           
           var $container = $(this);

           $container.find('.slider-for').slick({
               slidesToShow: 1,
               slidesToScroll: 1,
               arrows: true,
               dots: true,
               fade: false,
               draggable: false,
               infinite: false,
               asNavFor: '.slider-nav'
           });
           $container.find('.slider-nav').slick({
               slidesToShow: 5,
               slidesToScroll: 1,
               asNavFor: '.slider-for',
               vertical: true,
               verticalSwiping: true,
               dots: false,
               arrows: false,
               focusOnSelect: true
           });
       }
   }
   customElements.define('product-gallery', SectionProductGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations2"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
    }
  };
  request.send();
};
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-review"]) return;
  try {
    
   
   class SectionProductReview extends HTMLElement {
       constructor() {
           super();
            var $container = $(this);
            $container.find('.trustspot-inline-product').appendTo($('.product-tt'));
       }
   }

   customElements.define('product-review', SectionProductReview);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-temp-clip-in-3Var"]) return;
  try {
    
  class SectionProductGallery extends HTMLElement {
     constructor() {
         super();
         
         var $container = $(this);

         $container.find('.slider-for').slick({
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows: true,
             dots: true,
             fade: false,
             draggable: false,
             infinite: true,
             asNavFor: '.slider-nav'
         });
         $container.find('.slider-nav').slick({
             slidesToShow: 5,
             slidesToScroll: 5,
             asNavFor: '.slider-for',
             vertical: true,
             verticalSwiping: true,
             dots: false,
             arrows: false,
             infinite: true,
             focusOnSelect: true
         });
     }
  }
  customElements.define('product-gallery', SectionProductGallery);

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-temp-video"]) return;
  try {
    
  class SectionProductGallery extends HTMLElement {
     constructor() {
         super();
         
         var $container = $(this);

         $container.find('.slider-for').slick({
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows: true,
             dots: false,
             fade: false,
             draggable: false,
             infinite: true,
             asNavFor: '.slider-nav'
         });
         $container.find('.slider-nav').slick({
             slidesToShow: 5,
             slidesToScroll: 5,
             asNavFor: '.slider-for',
             vertical: true,
             verticalSwiping: true,
             dots: false,
             arrows: false,
             infinite: true,
             focusOnSelect: true
         });
     }
  }
  customElements.define('product-gallery', SectionProductGallery);

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-clipin"] && !window.DesignMode) return;
  try {
    

   class SectionHeadingSub extends HTMLElement {
       constructor() {
           super();
            var $container = $(this);
            $container.find('.expand-more').click(function() {
               $container.find('.special-text-more').hide();
               $container.find('.special-text-less').show();
            });
            $container.find('.expand-less').click(function() {
               $container.find('.special-text-less').hide();
               $container.find('.special-text-more').show();
            });
       }
   }

   customElements.define('product-heading-sub', SectionHeadingSub);

   class SectionProductAccordion extends HTMLElement {
       constructor() {
           super();
            var $container = $(this);
            $container.find('.accordion-header').click(function() {
               if($container.hasClass('active')){
                  $container.removeClass('active');
                  $container.find('.accordion__content').css('display','none');
               }else{
                   $container.addClass('active');
                  $container.find('.accordion__content').css('display','block');
               }
           });
       }
   }

   customElements.define('product-accordion', SectionProductAccordion);

   class SectionStepPackage extends HTMLElement {
      constructor() {
         super();
         var $container = $(this); 
         var productSelectedStep2;
         var selectedOptions = {};
           
         if ($(window).width() < 768){
            $('.block--collection').each(function(){
               $(this).find('.icon-popup').click(function() {
                  $(this).closest('.collection_content').find('.popup-collection').show();
               });
            });
            
         }  
         $('.popup-show').click(function() {
            $('.popup-image').show();
         });
         $('.popup-close').click(function() {
            $('.popup-image').hide();
         });
         $('body').click(function(e) {
            var target = $(e.target);
             if(!target.is('.popup-show') && !target.is('.popup-image img')) {
                  $('.popup-image').hide();
             }
         });

         $('.btn-learn-more').click(function() {
            $('body').addClass('overlay-popup');
            $('.learn-more-content').show();
         });
         $('.close-popup-learnmore').click(function() {
            $('body').removeClass('overlay-popup');
            $('.learn-more-content').hide();
         });
         $('.step-title').click(function() {
            var step = $(this).data('step');
            var activatedStep = $('.step-title.current').data('step');
            var currentStep = $(this).closest('div');
            if (activatedStep <= step) {
               return false;
            }
            $('.step-content').hide();
            $(this).addClass('current');
            $(this).html(titles[step - 1]);
            currentStep.find('.step-content').show();
            $('.step-title').each(function() {
               var stepTmp = $(this).data('step');
               if (stepTmp > step) {
                  $(this).removeClass('current');
                  $(this).removeClass('passed');
                  $(this).html(titles[stepTmp - 1]);
               }
            });
            if(step==2){
               $(".back").trigger("click");
            }
         });
         $('.item-step1 .image-item').each(function() {
            $(this).click(function() {
               $('.item-step1').removeClass('selected');
               $(this).closest('.item-step1').addClass('selected');
            });
         });
 
         $('.btn-next-1').click(function(){
            $('.step2 .step-title').addClass('current');
            $('.step2 .list-item-color').show();
            $('.step2 .item-details').hide();
            $('.item-step1.selected').each(function() {
               if ($(this).hasClass('selected')) {
                  var collection = $(this).attr('data-collection');
                  var blockTitle = $(this).find('.collection-title').html();
                  $('.step1 .step-title').addClass('passed').removeClass('current').html('1. ' + blockTitle);
                  $('.step1 .step-content').hide();
                  $('.step2 .step-content').show();
                  $('.step2 ul.list-item-color').html('');
                  $.get('/collections/' + collection + '?view=custom', function(response) {
                     var data = JSON.parse(response);
                     if (data.products) {
                        showStep2(data.products)
                     }
                  });
               }
            });
         });
         if ($('#modal-trigger').length) {
            $('.btn-next-1').trigger('click');
         }

         $('.step2 .back').click(function() {
            $('.step2 .list-item-color').show();
            $('.step2 .item-details').hide();
         });

         function initStep2ImageSlides(images) {
            images.slick({
               slidesToShow: 1,
               slidesToScroll: 1,
               initialSlide:1,
               arrows: true,
               fade: true,
               draggable: false,
               infinite: false,
            });
         }

         function showStep2ItemDetails(product) {
            $('.step2 .list-item-color').hide();
            $('.step2 .item-details').show();
            $('.step2 .description').html('');
            $('.step2 .item-details ul.item-images').remove();
            var imageHtmlWrap = $('<ul class="item-images"></ul>');
            product.images.forEach(function(img) {
               var imageHtml = $('<li><div class="img"><img src="' + img + '"/></div></li>');
               imageHtml.appendTo(imageHtmlWrap);
            });
            imageHtmlWrap.insertBefore($('.step2 .product_description'));
            initStep2ImageSlides(imageHtmlWrap);
            $.get('/products/' + product.handle + '?view=metafields', function(response) {
               var data = JSON.parse(response);
               $('<h4>' + data.metafields.title + '</h4>').appendTo($('.step2 .description'));
               $('<div class = "details">' + data.metafields.description + '</div>').appendTo($('.step2 .description'));
               product.optionPrices = getOptionPrices(data.variants);
               product.allowedOptions = getOptions(data.variants);
            });
            productSelectedStep2 = product;
            $([document.documentElement, document.body]).animate({
               scrollTop: $(".step2 > .step-title").offset().top - 30
            }, 500);
         }

         function getOptionPrices(variants) {
            var optionPrices = [];
            variants.forEach(function(variant) {
               var variantId = variant.id;
               optionPrices[variantId] = variant.price;
            });
            return optionPrices;
         }

         function getOptions(variants) {
            var options = {'option1': [], 'option2': [], 'option3': []};
            variants.forEach(function(variant) {
               if (variant.option1 != '') {
                  var check = checkOptionExist(options.option1, variant.option1);
                  if (check === -1) {
                     options.option1.push({'label': variant.option1, 'products': [{id: variant.id, available: variant.available}]});
                  } else {
                     options.option1[check].products.push({id: variant.id, available: variant.available});
                  }
               }
               if (variant.option2 != '') {
                  var check = checkOptionExist(options.option2, variant.option2);
                  if (check === -1) {
                     options.option2.push({'label': variant.option2, 'products': [{id: variant.id, available: variant.available}]});
                  } else {
                     options.option2[check].products.push({id: variant.id, available: variant.available});
                  }
               }
               if (variant.option3 != '') {
                  var check = checkOptionExist(options.option3, variant.option3);
                  if (check === -1) {
                     options.option3.push({'label': variant.option3, 'products': [{id: variant.id, available: variant.available}]});
                  } else {
                     options.option3[check].products.push({id: variant.id, available: variant.available});
                  }
               }
            });
            return options;
         }

         function checkOptionExist(options, optionLabel) {
            var index = -1;
            for(var i = 0; i < options.length; i++) {
               if (options[i].label == optionLabel) {
                  index = i;
               }
            }
            return index;
         }

         function getAllowedProductWithMinPrice(allowedProducts) {
            var optionPrices = productSelectedStep2.optionPrices,
               product = '',
               optionMinPrice, optionFinalPrice;
            allowedProducts.forEach(function(allowedProduct) {
               optionFinalPrice = optionPrices[allowedProduct.id];
               if (product == '' || optionFinalPrice < optionMinPrice) {
                  optionMinPrice = optionFinalPrice;
                  product = optionFinalPrice
               }
            });
            return optionMinPrice;
         }

         function isOptionAvailable(allowedProducts) {
            var flag = false;
            allowedProducts.forEach(function(allowedProduct) {
               if (allowedProduct.available === true) {
                  flag = true;
               }
            });
            return flag;
         }

         function getTags(productTags) {
            var html = '';
            productTags.forEach(function(prodTag) {
               if (tagCond.indexOf(prodTag) != -1) {
                  if (html == '') {
                     html += prodTag;
                  } else {
                     html += ',' + prodTag; 
                  }
               }
            });
            return html;
         }

         function showStep2(products) {
            products.forEach(function(prod) {
               var itemHtml = $('<li data-handle="' + prod.handle + '"><div class="image-color"><a><img  src="' + prod.images[1] + '"/></a></div><div class="prod-tag">' + getTags(prod.tags) + '</div><div class="title-color"><a>' + prod.title + '</a></div></li>');
               itemHtml.click(function() {
                  $('.step2 ul.list-item-color li').removeClass('selected');
                  $(this).addClass('selected');
                  showStep2ItemDetails(prod);
               })
               $('.step2 ul.list-item-color').append(itemHtml);
               var cw = itemHtml.find('.image-color').width();
               itemHtml.find('.image-color').css({'height':cw+'px'});
            });
         }

         $('.btn-next-2').click(function() {
            showStep3();
         });

         function showStep3() {
            var product = productSelectedStep2;
            $('.step3 .step-title').addClass('current');
            $('.step2 .step-content').hide();
            $('.step3 .step-content').show();
            $('.step3 .list-items').html('');
            $('.step2 .step-title').addClass('passed').removeClass('current');
            $('.step2 .step-title').html('2.' + $('.step2 .product_description h4').html());
            var itemHtmlWrap = $('<ul class="list-extra-length list-option-variants"></ul>');
            var count = 1;
            product.allowedOptions.option1.forEach(function(option) {
               var imageName = 'clipin_option_' + option.label;
               imageName = imageName.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
               imageName = imageName.replace(/ /g, '_');
               imageName = imageName.toLowerCase();
               var imageSrc = '';
               product.images.forEach(function(img) {
                  if (img.indexOf(imageName) !== -1) {
                     imageSrc = img;
                     return true;
                  }
               })
               var price = Intl.NumberFormat(Shopify.locale, {
                  style: 'currency',
                  currency: Shopify.currency.active,
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2,
               }).format(getAllowedProductWithMinPrice(option.products)/100);
               var disabled = !isOptionAvailable(option.products) ? 'disabled' : '';
               var extraContentHTML = '';
               var iconExtra = '';
               var classInfo = '';
               if (count==2 && imageExtraLength != '' && imageExtraLength != null) {
                  extraContentHTML = '<div class="popup-info popup-extralength"><img src= "' +imageExtraLength+'"/><div class="content-info">' + contentExtraLength +'</div></div>';
                  iconExtra = '<a class="icon-extralength"></a>';
                  classInfo = 'has-info';
               } 
               var itemHtml = $('<li class="' + disabled +'" data-value="' + option.label + '"><div class="image"><img src="'+imageSrc+'"/></div><div class="extra-length-option ' + classInfo + '"><div class="label-option">' + option.label + iconExtra + extraContentHTML + '</div><div class="price">starting at ' + price + '</div></div></li>');
               itemHtml.appendTo(itemHtmlWrap);
               if (disabled == '') {
                  itemHtml.click(function() {
                     $('.step3 .list-items li').removeClass('selected');
                     $(this).addClass('selected');
                     selectedOptions.option1 = option.label;
                  });
               }
               count ++;
            });
            itemHtmlWrap.appendTo($('.step3 .list-items'));
            itemHtmlWrap.find('li:not(".disabled"):first').trigger('click');
            var cw = itemHtmlWrap.find('.image').width();
            itemHtmlWrap.find('.image').css({'height':cw+'px'});
            if ($(window).width() < 768){
               $('.icon-extralength').click(function() {
                  $('.popup-extralength').show();
               }); 
               $('body').click(function(e) {
                  var target = $(e.target);
                  if(!target.is('.icon-extralength') && !target.is('.popup-extralength')) {
                     $('.popup-extralength').hide();
                  }
               });
            }
            if (itemHtmlWrap.find('li:not(".disabled")').length == 1) {
                $('.btn-next-3').trigger('click');
            }
         }

         $('.btn-next-3').click(function() {
            showStep4();
         });

         function showStep4() {
            var product = productSelectedStep2;
            $('.step4 .step-title').addClass('current');
            $('.step3 .step-content').hide();
            $('.step4 .step-content').show();
            $('.step4 .list-items').html('');
            $('.step3 .step-title').addClass('passed').removeClass('current');
            $('.step3 .step-title').html('3.' + $('.step3 li.selected .label-option').html());
            var itemHtmlWrap = $('<ul class="list-base list-option-variants"></ul>');
            var count = 1;
            product.allowedOptions.option2.forEach(function(option) {
               var imageName = 'base_option_' + option.label;
               imageName = imageName.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
               imageName = imageName.replace(/ /g, '_');
               imageName = imageName.toLowerCase();
               var imageSrc = '';
               product.images.forEach(function(img) {
                  if (img.indexOf(imageName) !== -1) {
                     imageSrc = img;
                  }
               })
               var minPrice = getAllowedProductWithMinPrice(option.products);
               var price = Intl.NumberFormat(Shopify.locale, {
                  style: 'currency',
                  currency: Shopify.currency.active,
               }).format(minPrice/100);
               var diffPrice = minPrice - product.price;
               var priceHtml = diffPrice > 0 ? '<span class="price">+' + Intl.NumberFormat(Shopify.locale, {
                  style: 'currency',
                  currency: Shopify.currency.active,
               }).format(diffPrice/100) + '</span>' : '';
               var disabled = !isOptionAvailable(option.products) ? 'disabled' : '';
               var invisibleContentHTML = '';
               var classInfo2 = '';
               var iconInvisible = '';
               if (count==2 && imageInvisible != '' && imageInvisible != null) {
                  invisibleContentHTML = '<div class="popup-info popup-invisible"><img src= "' +imageInvisible+'"/><div class="content-info">' + contentInvisible +'</div></div>';
                  iconInvisible = '<a class="icon-invisible"></a>';
                  classInfo2 = 'has-info';
               } 
               var itemHtml = $('<li class="' + disabled +'" data-value="' + option.label + '"><div class="image"><img src="'+imageSrc+'"/></div><div class="invisible-option ' + classInfo2 + ' "><div class="label-option">' + option.label + iconInvisible + invisibleContentHTML + '</div>' + priceHtml + '</div></li>');
               itemHtml.appendTo(itemHtmlWrap);
               if (disabled == '') {
                  itemHtml.click(function() {
                     $('.step4 .list-items li').removeClass('selected');
                     $(this).addClass('selected');
                     selectedOptions.option2 = option.label;
                  });
               }
               count ++;
            });
            itemHtmlWrap.appendTo($('.step4 .list-items'));
            itemHtmlWrap.find('li:not(".disabled"):first').trigger('click');
            var cw = itemHtmlWrap.find('.image').width();
            itemHtmlWrap.find('.image').css({'height':cw+'px'});
            if ($(window).width() < 768){
               $('.icon-invisible').click(function() {
                  $('.popup-invisible').show();
               }); 
               $('body').click(function(e) {
                  var target = $(e.target);
                  if(!target.is('.icon-invisible') && !target.is('.popup-invisible')) {
                     $('.popup-invisible').hide();
                  }
               }); 
            } 
            if (itemHtmlWrap.find('li:not(".disabled")').length == 1) {
                $('.btn-next-4').trigger('click');
            } 
         }

         $('.btn-next-4').click(function() {
            showStep5();
         });

         function showStep5() {
            var product = productSelectedStep2;
            $('.step5 .step-title').addClass('current');
            $('.step4 .step-content').hide();
            $('.step5 .step-content').show();
            $('.step5 .list-items').html('');
            $('.step4 .step-title').addClass('passed').removeClass('current');
            $('.step4 .step-title').html('4.' + $('.step4 li.selected .label-option').html());
            var itemHtmlWrap = $('<ul class="list-length"></ul>');
            product.allowedOptions.option3.forEach(function(option) {
               var tmpSelectedOptions = selectedOptions;
               tmpSelectedOptions.option3 = option.label;
               var disabled = !getSelectedProduct(tmpSelectedOptions) ? 'disabled' : '';
               var itemHtml = $('<li class="' + disabled +'" data-value="' + option.label + '">' + option.label + '</li>');
               itemHtml.appendTo(itemHtmlWrap);
               if (disabled == '') {
                  itemHtml.click(function() {
                     $('.step5 .list-items li').removeClass('selected');
                     $(this).addClass('selected');
                     selectedOptions.option3 = option.label;
                     var selectedProduct = getSelectedProduct(selectedOptions);
                     updateKrana(selectedProduct.price); 
                     var price = Intl.NumberFormat(Shopify.locale, {
                        style: 'currency',
                        currency: Shopify.currency.active,
                     }).format(selectedProduct.price/100);
                     var comparePrice = '';
                     if (selectedProduct.compare_at_price) {
                        comparePrice = Intl.NumberFormat(Shopify.locale, {
                           style: 'currency',
                           currency: Shopify.currency.active,
                        }).format(selectedProduct.compare_at_price/100);
                     }
                     $('input[name="id"]').val(selectedProduct.id);
                     $('a.addtocart').attr('data-pricetext', price + '<span class="comparePrice">' + comparePrice + '</span>' + ' - Add to cart').html(price + '<span class="comparePrice">' + comparePrice + '</span>' + ' - Add to cart').show();
                  });
               }
            });
            itemHtmlWrap.appendTo($('.step5 .list-items'));
            itemHtmlWrap.find('li:not(".disabled"):first').trigger('click');
            if ($(window).width() < 768){
               $('.icon-popup-shipping').click(function() {
                  $('.popup-shipping').show();
               });
               $('body').click(function(e) {
                  var target = $(e.target);
                  if(!target.is('.icon-popup-shipping') && !target.is('.popup-shipping')) {
                     $('.popup-shipping').hide();
                  }
               }); 
            }  
         }

         function updateKrana(price) {
            var kranaPrice = price / 4;
            var price = Intl.NumberFormat(Shopify.locale, {
                  style: 'currency',
                  currency: Shopify.currency.active,
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2,
               }).format(kranaPrice/100);
            $('.price-payment').html(price);
         }

         function getSelectedProduct(tmpSelectedOptions) {
            var product;
            productSelectedStep2.variants.forEach(function(variant) {
               if (variant.option1 == tmpSelectedOptions.option1 && variant.option2 == tmpSelectedOptions.option2 && variant.option3 == tmpSelectedOptions.option3 && variant.available) {
                  product = variant;
               }
            });
            return product;
         }
      }
   }

   customElements.define('step-package', SectionStepPackage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-pick-color"]) return;
  try {
    
   
   class SectionHeadingSub extends HTMLElement {
       constructor() {
           super();
            var $container = $(this);
            $container.find('.expand-more').click(function() {
               $container.find('.special-text-more').hide();
               $container.find('.special-text-less').show();
            });
            $container.find('.expand-less').click(function() {
               $container.find('.special-text-less').hide();
               $container.find('.special-text-more').show();
            });
       }
   }

   customElements.define('product-heading-sub', SectionHeadingSub);

   class SectionProductAccordion extends HTMLElement {
       constructor() {
           super();
            var $container = $(this);
            $container.find('.accordion-header').click(function() {
               if($container.hasClass('active')){
                  $container.removeClass('active');
                  $container.find('.accordion__content').css('display','none');
               }else{
                   $container.addClass('active');
                  $container.find('.accordion__content').css('display','block');
               }
           });
       }
   }

   customElements.define('product-accordion', SectionProductAccordion);

   class SectionStepPackage extends HTMLElement {
      constructor() {
         super();
         
         var $container = $(this); 

         $('.js-show-item-details').on('click', function() {
            $(this).closest('.list-item-color').addClass('show-details');

            $('.js-show-item-details').hide();
            $(this).next().show().addClass('selected');

            if(!$('.item-details.selected .item-images').hasClass('slick-slider')) {
               $('.item-details.selected .item-images').slick({
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  arrows: true,
                  fade: true,
                  draggable: false,
                  infinite: false,
               });
            }

            $([document.documentElement, document.body]).animate({
               scrollTop: $('.step2 > .step-title').offset().top - 30
            }, 500);
         });

         $('.js-back-shades').on('click', function() {
            $(this).closest('.list-item-color').removeClass('show-details');
            $(this).closest('.item-details').hide().removeClass('selected');
            $('.js-show-item-details').show();
         });
      }
   }

   customElements.define('step-package', SectionStepPackage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-tapein"] && !window.DesignMode) return;
  try {
    

   class SectionHeadingSub extends HTMLElement {
       constructor() {
           super();
            var $container = $(this);
            $container.find('.expand-more').click(function() {
               $container.find('.special-text-more').hide();
               $container.find('.special-text-less').show();
            });
            $container.find('.expand-less').click(function() {
               $container.find('.special-text-less').hide();
               $container.find('.special-text-more').show();
            });
       }
   }

   customElements.define('product-heading-sub', SectionHeadingSub);

   class SectionProductAccordion extends HTMLElement {
       constructor() {
           super();
            var $container = $(this);
            $container.find('.accordion-header').click(function() {
               if($container.hasClass('active')){
                  $container.removeClass('active');
                  $container.find('.accordion__content').css('display','none');
               }else{
                   $container.addClass('active');
                  $container.find('.accordion__content').css('display','block');
               }
           });
       }
   }

   customElements.define('product-accordion', SectionProductAccordion);

   class SectionStepPackage extends HTMLElement {
      constructor() {
         super();
        
         var $container = $(this); 
         var productSelectedStep2;
         var selectedOptions = {};
         var selectedGoal = 1;
         if ($(window).width() < 768){
            $('.block--collection').each(function(){
               $(this).find('.icon-popup').click(function() {
                  $(this).closest('.collection_content').find('.popup-collection').show();
               });
            });
         }  

         $('.popup-show').click(function() {
            $('.popup-image').show();
         });
         $('.popup-close').click(function() {
            $('.popup-image').hide();
         });
         $('body').click(function(e) {
            var target = $(e.target);
             if(!target.is('.popup-show') && !target.is('.popup-image img')) {
                  $('.popup-image').hide();
             }
         });

         $('.btn-learn-more').click(function() {
            $('body').addClass('overlay-popup');
            $('.learn-more-content').show();
         });
         $('.close-popup-learnmore').click(function() {
            $('body').removeClass('overlay-popup');
            $('.learn-more-content').hide();
         });

         function getQueryParams(qs) {
             qs = qs.split('+').join(' ');

             var params = {},
                 tokens,
                 re = /[?&]?([^=]+)=([^&]*)/g;

             while (tokens = re.exec(qs)) {
                 params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
             }

             return params;
         }
         
         $("button.btnqty ").on("click", function(ev) {
           var currentQty = $('input[name="quantity"]').val();
           var qtyDirection = $(this).data("direction");
           var newQty = 0;
           
           if (qtyDirection == "1") {
             newQty = parseInt(currentQty) + 1;
           }
           else if (qtyDirection == "-1") {
             newQty = parseInt(currentQty) - 1;
           }

           // make decrement disabled at 1
           if (newQty == 1) {
             $(".qtyminus").attr("disabled", "disabled");
           }
           
           // remove disabled attribute on subtract
           if (newQty > 1) {
             $(".qtyminus").removeAttr("disabled");
           }
           
           if (newQty > 0) {
             newQty = newQty.toString();
             $('input[name="quantity"]').val(newQty);
           }
           else {
             $('input[name="quantity"]').val("1");
           }
           
           $('a.addtocart').attr('href',  '/cart/add?id=' + $('a.addtocart').data('id') + '&quantity=' + $('input[name="quantity"]').val());
           var selectedProduct = getSelectedProduct(selectedOptions);
           var price = Intl.NumberFormat(Shopify.locale, {
                        style: 'currency',
                        currency: Shopify.currency.active,
                     }).format($('input[name="quantity"]').val()*selectedProduct.price/100);
           $('a.addtocart span').html(price)
         });
         $('.step-title').click(function() {
            var step = $(this).data('step');
            var activatedStep = $('.step-title.current').data('step');
            var currentStep = $(this).closest('div');
            if (activatedStep <= step) {
               return false;
            }
            $('.step-content').hide();
            $(this).addClass('current');
            $(this).html(titles[step - 1]);
            currentStep.find('.step-content').show();
            $('.step-title').each(function() {
               var stepTmp = $(this).data('step');
               if (stepTmp > step) {
                  $(this).removeClass('current');
                  $(this).removeClass('passed');
                  $(this).html(titles[stepTmp - 1]);
               }
            });
            if(step==2){
               $(".back").trigger("click");
            }
         });

         $('.item-type').click(function() {
            $('.item-type').removeClass('selected');
            $(this).addClass('selected');
         });

         $('.item-step1 .image-item').each(function() {
            $(this).click(function() {
               $('.item-step1').removeClass('selected');
               $(this).closest('.item-step1').addClass('selected');
            });
         });

         $('.btn-next-1').click(function(){
            $('.step2 .step-title').addClass('current');
            $('.step2 .list-item-color').show();
            $('.step2 .item-details').hide();
            $('.item-step1.selected').each(function() {
               if ($(this).hasClass('selected')) {
                  var collection = $(this).attr('data-collection');
                  var blockTitle = $(this).find('.collection-title').html();
                  $('.step1 .step-title').addClass('passed').removeClass('current').html('1. ' + blockTitle);
                  $('.step1 .step-content').hide();
                  $('.step2 .step-content').show();
                  $('.step2 ul.list-item-color').html('');
                  $.get('/collections/' + collection + '?view=custom', function(response) {
                     var data = JSON.parse(response);
                     if (data.products) {
                        showStep2(data.products)
                     }
                  });
               }
            });
         });
         if ($('#modal-trigger').length) {
            $('.btn-next-1').trigger('click');
         }

         $('.step2 .back').click(function() {
            $('.step2 .list-item-color').show();
            $('.step2 .item-details').hide();
         });

         function initStep2ImageSlides(images) {
            images.slick({
               slidesToShow: 1,
               slidesToScroll: 1,
               initialSlide:1,
               arrows: true,
               fade: true,
               draggable: false,
               infinite: false,
            });
         }

         function showStep2ItemDetails(product) {
            $('.step2 .list-item-color').hide();
            $('.step2 .item-details').show();
            $('.step2 .description').html('');
            $('.step2 .item-details ul.item-images').remove();
            var imageHtmlWrap = $('<ul class="item-images"></ul>');
            product.images.forEach(function(img) {
               var imageHtml = $('<li><div class="img"><img src="' + img + '"/></div></li>');
               imageHtml.appendTo(imageHtmlWrap);
            });
            imageHtmlWrap.insertBefore($('.step2 .product_description'));
            initStep2ImageSlides(imageHtmlWrap);
            $.get('/products/' + product.handle + '?view=metafields', function(response) {
               var data = JSON.parse(response);
               $('<h4>' + data.metafields.title + '</h4>').appendTo($('.step2 .description'));
               $('<div class = "details">' + data.metafields.description + '</div>').appendTo($('.step2 .description'));
               product.optionPrices = getOptionPrices(data.variants);
               product.allowedOptions = getOptions(data.variants);
            });
            productSelectedStep2 = product;
            console.log(product);
            $([document.documentElement, document.body]).animate({
               scrollTop: $(".step2 > .step-title").offset().top - 30
            }, 500);
         }

         function getOptionPrices(variants) {
            var optionPrices = [];
            variants.forEach(function(variant) {
               var variantId = variant.id;
               optionPrices[variantId] = variant.price;
            });
            return optionPrices;
         }

         function getOptions(variants) {
            var options = {'option1': [], 'option2': []};
            variants.forEach(function(variant) {
               if (variant.option1 != '') {
                  var check = checkOptionExist(options.option1, variant.option1);
                  if (check === -1) {
                     options.option1.push({'label': variant.option1, 'products': [{id: variant.id, available: variant.available}]});
                  } else {
                     options.option1[check].products.push({id: variant.id, available: variant.available});
                  }
               }
               if (variant.option2 != '') {
                  var check = checkOptionExist(options.option2, variant.option2);
                  if (check === -1) {
                     options.option2.push({'label': variant.option2, 'products': [{id: variant.id, available: variant.available}]});
                  } else {
                     options.option2[check].products.push({id: variant.id, available: variant.available});
                  }
               }
            });
            return options;
         }

         function checkOptionExist(options, optionLabel) {
            var index = -1;
            for(var i = 0; i < options.length; i++) {
               if (options[i].label == optionLabel) {
                  index = i;
               }
            }
            return index;
         }

         function getAllowedProductWithMinPrice(allowedProducts) {
            var optionPrices = productSelectedStep2.optionPrices,
               product = '',
               optionMinPrice, optionFinalPrice;
            allowedProducts.forEach(function(allowedProduct) {
               optionFinalPrice = optionPrices[allowedProduct.id];
               if (product == '' || optionFinalPrice < optionMinPrice) {
                  optionMinPrice = optionFinalPrice;
                  product = optionFinalPrice
               }
            });
            return optionMinPrice;
         }

         function isOptionAvailable(allowedProducts) {
            var flag = false;
            allowedProducts.forEach(function(allowedProduct) {
               if (allowedProduct.available === true) {
                  flag = true;
               }
            });
            return flag;
         }

         function getTags(productTags) {
            var html = '';
            productTags.forEach(function(prodTag) {
               if (tagCond.indexOf(prodTag) != -1) {
                  if (html == '') {
                     html += prodTag;
                  } else {
                     html += ',' + prodTag; 
                  }
               }
            });
            return html;
         }

         function showStep2(products) {
            products.forEach(function(prod) {
               var itemHtml = $('<li data-handle="' + prod.handle + '"><div class="image-color"><a><img  src="' + prod.images[1] + '"/></a></div><div class="prod-tag">' + getTags(prod.tags) + '</div><div class="title-color"><a>' + prod.title + '</a></div></li>');
               itemHtml.click(function() {
                  $('.step2 ul.list-item-color li').removeClass('selected');
                  $(this).addClass('selected');
                  showStep2ItemDetails(prod);
               })
               $('.step2 ul.list-item-color').append(itemHtml);
               var cw = itemHtml.find('.image-color').width();
               itemHtml.find('.image-color').css({'height':cw+'px'});
            });
         }

         $('.btn-next-2').click(function() {
            showStep3();
         });

         function showStep3() {
            var product = productSelectedStep2;
            $('.step3 .step-title').addClass('current');
            $('.step2 .step-content').hide();
            $('.step3 .step-content').show();
            $('.step3 .list-items').html('');
            $('.step2 .step-title').addClass('passed').removeClass('current');
            $('.step2 .step-title').html('2. ' + $('.step2 .product_description h4').html());
            $('.item-goal').each(function() {
               $(this).unbind('click').click(function() {
                  $('.step3 .list-goals-wrapper .item-goal').removeClass('selected');
                  $(this).addClass('selected');
                  selectedGoal = $(this).data('goal');
               });
            });
         }

         $('.btn-next-3').click(function() {
            showStep4();
         });

         function showStep4() {
            var product = productSelectedStep2;
            $('.step4 .step-title').addClass('current');
            $('.step3 .step-content').hide();
            $('.step4 .step-content').show();
            $('.step4 .list-items').html('');
            $('.step3 .step-title').addClass('passed').removeClass('current');
            $('.step3 .step-title').html('3. ' + $('.step3 .item-type.selected h4 ').html() + ' and ' + $('.step3 .item-goal.selected h4 ').html() );
            var itemHtmlWrap = $('<ul class="list-base list-option-variants"></ul>');
            var count = 1;
            product.allowedOptions.option1.forEach(function(option) {
               var imageName = 'base_option_' + option.label;
               imageName = imageName.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
               imageName = imageName.replace(/ /g, '_');
               imageName = imageName.toLowerCase();
               var imageSrc = '';
               product.images.forEach(function(img) {
                  if (img.indexOf(imageName) !== -1) {
                     imageSrc = img;
                  }
               })
               var minPrice = getAllowedProductWithMinPrice(option.products);
               var price = Intl.NumberFormat(Shopify.locale, {
                  style: 'currency',
                  currency: Shopify.currency.active,
               }).format(minPrice/100);
               var diffPrice = minPrice - product.price;
               var priceHtml = diffPrice > 0 ? '<span class="price"> +' + Intl.NumberFormat(Shopify.locale, {
                  style: 'currency',
                  currency: Shopify.currency.active,
               }).format(diffPrice/100) + '</span>' : '';
               var disabled = !isOptionAvailable(option.products) ? 'disabled' : '';
               var invisibleContentHTML = '';
               var iconInvisible = '';
               var classInfo2 = '';
               if (count==2 && imageInvisible != '' && imageInvisible != null) {
                  invisibleContentHTML = '<div class="popup-info popup-invisible"><img src= "' + imageInvisible +'"/><div class="content-info">' + contentInvisible +'</div></div>';
                  iconInvisible = '<a class="icon-invisible"></a>';
                  classInfo2 = 'has-info';
               } 
                var itemHtml = $('<li class="' + disabled +'" data-value="' + option.label + '"><div class="image"><img src="'+imageSrc+'"/></div><div class="invisible-option ' + classInfo2 + ' "><div class="label-option">' + option.label + iconInvisible + invisibleContentHTML + '</div>' + priceHtml + '</div></li>');
               itemHtml.appendTo(itemHtmlWrap);   
               if (disabled == '') { 
                  itemHtml.click(function() {
                     $('.step4 .list-items li').removeClass('selected');
                     $(this).addClass('selected');
                     selectedOptions.option1 = option.label;
                  });
               }
               count ++; 
            });
            itemHtmlWrap.appendTo($('.step4 .list-items'));
            itemHtmlWrap.find('li:not(".disabled"):first').trigger('click');
            var cw = itemHtmlWrap.find('.image').width();
            itemHtmlWrap.find('.image').css({'height':cw+'px'});
            if ($(window).width() < 768){
               $('.icon-invisible').click(function() {
                  $('.popup-invisible').show();
               }); 
               $('body').click(function(e) {
                  var target = $(e.target);
                  if(!target.is('.icon-invisible') && !target.is('.popup-invisible')) {
                     $('.popup-invisible').hide();
                  }
               }); 
            }

            if (itemHtmlWrap.find('li:not(".disabled")').length == 1) {
                $('.btn-next-4').trigger('click');
            }
         }

         $('.btn-next-4').click(function() {
            showStep5();
         });

         function getPack() {
            var type = $('.item-type.selected').data('type');
            if ((type == 1 && selectedGoal == 1) || (type == 2 && selectedGoal == 1)) {
               return 2;
            }
            if ((type == 1 && selectedGoal == 2) || (type == 2 && selectedGoal == 2) || (type == 3 && selectedGoal == 1)) {
               return 3;
            }
            if ((type == 3 && selectedGoal == 2)) {
               return 4;
            }
            return 1;
         }

         function showStep5() {
            var product = productSelectedStep2;
            var pack = getPack();
            $('.step5 .step-title').addClass('current');
            $('.step4 .step-content').hide();
            $('.step5 .step-content').show();
            $('.step5 .list-items').html('');
            $('.step4 .step-title').addClass('passed').removeClass('current');
            $('.step4 .step-title').html('4.' + $('.step4 li.selected .label-option').html());
            $('#quantity').val(pack);
            if (pack > 1) {
               $(".qtyminus").removeAttr("disabled");
            }
            $('.pack-info .count').html(pack);
            var itemHtmlWrap = $('<ul class="list-length"></ul>');
            product.allowedOptions.option2.forEach(function(option) {
               var tmpSelectedOptions = selectedOptions;
               tmpSelectedOptions.option2 = option.label;
               var disabled = !getSelectedProduct(tmpSelectedOptions) ? 'disabled' : '';
               var itemHtml = $('<li class="' + disabled +'" data-value="' + option.label + '">' + option.label + '</li>');
               itemHtml.appendTo(itemHtmlWrap);
               if (disabled == '') {
                  itemHtml.click(function() {
                     $('.step5 .list-items li').removeClass('selected');
                     $(this).addClass('selected');
                     selectedOptions.option2 = option.label;
                     var selectedProduct = getSelectedProduct(selectedOptions);
                     updateKrana(selectedProduct.price);
                     var quantity = $('#quantity').val();
                     var price = Intl.NumberFormat(Shopify.locale, {
                        style: 'currency',
                        currency: Shopify.currency.active,
                     }).format(quantity*selectedProduct.price/100);
                     var comparePrice = '';
                     if (selectedProduct.compare_at_price) {
                        comparePrice = Intl.NumberFormat(Shopify.locale, {
                           style: 'currency',
                           currency: Shopify.currency.active,
                        }).format(quantity*selectedProduct.compare_at_price/100);
                     }
                     $('input[name="id"]').val(selectedProduct.id);
                     $('a.addtocart').attr('data-pricetext', '<span>' + price + '<span class="comparePrice">' + comparePrice + '</span></span> - Add to cart').attr('data-id', selectedProduct.id).html('<span>' + price + '<span class="comparePrice">' + comparePrice + '</span></span> - Add to cart').show();
                  });
               }
            });
            itemHtmlWrap.appendTo($('.step5 .list-items'));
            itemHtmlWrap.find('li:not(".disabled"):first').trigger('click');
            if ($(window).width() < 768){
               $('.icon-popup-shipping').click(function() {
                  $('.popup-shipping').show();
               });
               $('body').click(function(e) {
                  var target = $(e.target);
                  if(!target.is('.icon-popup-shipping') && !target.is('.popup-shipping')) {
                     $('.popup-shipping').hide();
                  }
               }); 
            } 
         }

         function updateKrana(price) {
            var kranaPrice = price / 4;
            var price = Intl.NumberFormat(Shopify.locale, {
                  style: 'currency',
                  currency: Shopify.currency.active,
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2,
               }).format(kranaPrice/100);
            $('.price-payment').html(price);
         }

         function getSelectedProduct(tmpSelectedOptions) {
            var product;
            console.log(tmpSelectedOptions);
            productSelectedStep2.variants.forEach(function(variant) {
               if (variant.option1 == tmpSelectedOptions.option1 && variant.option2 == tmpSelectedOptions.option2 && variant.available) {
                  product = variant;
               }
            });
            return product;
         }
      }
   }

   customElements.define('step-package', SectionStepPackage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"] && !window.DesignMode) return;
  try {
    
   
   class SectionHeadingSub extends HTMLElement {
       constructor() {
           super();
            var $container = $(this);
            $container.find('.expand-more').click(function() {
               $container.find('.special-text-more').hide();
               $container.find('.special-text-less').show();
            });
            $container.find('.expand-less').click(function() {
               $container.find('.special-text-less').hide();
               $container.find('.special-text-more').show();
            });
       }
   }

   customElements.define('product-heading-sub', SectionHeadingSub);
   class SectionProductAccordion extends HTMLElement {
       constructor() {
           super();
            var $container = $(this);
            $container.find('.accordion-header').click(function() {
               if($container.hasClass('active')){
                  $container.removeClass('active');
                  $container.find('.accordion__content').css('display','none');
               }else{
                   $container.addClass('active');
                  $container.find('.accordion__content').css('display','block');
               }
           });
       }
   }

   customElements.define('product-accordion', SectionProductAccordion);

   class SectionStepPackage extends HTMLElement {
      constructor() {
         super();
         
        
         var $container = $(this); 
         var productSelectedStep2;

         if ($(window).width() < 768){
            $('.block--collection').each(function(){
               $(this).find('.icon-popup').click(function() {
                  $(this).closest('.collection_content').find('.popup-collection').show();
               });
            });
         }  
         
         $('.popup-show').click(function() {
            $('.popup-image').show();
         });
         $('.popup-close').click(function() {
            $('.popup-image').hide();
         });
         $('body').click(function(e) {
            var target = $(e.target);
             if(!target.is('.popup-show') && !target.is('.popup-image img')) {
                  $('.popup-image').hide();
             }
         });

         $('.btn-learn-more').click(function() {
            $('body').addClass('overlay-popup');
            $('.learn-more-content').show();
         });
         $('.close-popup-learnmore').click(function() {
            $('body').removeClass('overlay-popup');
            $('.learn-more-content').hide();
         });
         $('.step-title').click(function() {
            var step = $(this).data('step');
            var activatedStep = $('.step-title.current').data('step');
            var currentStep = $(this).closest('div');
            if (activatedStep <= step) {
               return false;
            }
            $('.step-content').hide();
            $(this).addClass('current');
            $(this).html(titles[step - 1]);
            currentStep.find('.step-content').show();
            $('.step-title').each(function() {
               var stepTmp = $(this).data('step');
               if (stepTmp > step) {
                  $(this).removeClass('current');
                  $(this).removeClass('passed');
                  $(this).html(titles[stepTmp - 1]);
               }
            });
            if(step==2){
               $(".back").trigger("click");
            }
         });

         $('.item-step1 .image-item').each(function() {
            $(this).click(function() {
               $('.item-step1').removeClass('selected');
               $(this).closest('.item-step1').addClass('selected');
            });
         });
         $('.btn-next-1').click(function(){
            $('.step2 .step-title').addClass('current');
            $('.step2 .list-item-color').show();
            $('.step2 .item-details').hide();
            $('.item-step1.selected').each(function() {
               if ($(this).hasClass('selected')) {
                  var collection = $(this).attr('data-collection');
                  var blockTitle = $(this).find('.collection-title').html();
                  $('.step1 .step-title').addClass('passed').removeClass('current').html('1. ' + blockTitle);
                  $('.step1 .step-content').hide();
                  $('.step2 .step-content').show();
                  $('.step2 ul.list-item-color').html('');
                  $.get('/collections/' + collection + '?view=custom', function(response) {
                     var data = JSON.parse(response);
                     if (data.products) {
                        showStep2(data.products)
                     }
                  });
               }
            });
         });
         if ($('#modal-trigger').length) {
            $('.btn-next-1').trigger('click');
         }
         $('.step2 .back').click(function() {
            $('.step2 .list-item-color').show();
            $('.step2 .item-details').hide();
         });

         function initStep2ImageSlides(images) {
            images.slick({
               slidesToShow: 1,
               slidesToScroll: 1,
               initialSlide:1,
               arrows: true,
               fade: true,
               draggable: false,
               infinite: false,
            });
         }

         function showStep2ItemDetails(product) {
            $('.step2 .list-item-color').hide();
            $('.step2 .item-details').show();
            $('.step2 .description').html('');
            $('.step2 .item-details ul.item-images').remove();
            var imageHtmlWrap = $('<ul class="item-images"></ul>');
            product.images.forEach(function(img) {
               var imageHtml = $('<li><div class="img"><img src="' + img + '"/></div></li>');
               imageHtml.appendTo(imageHtmlWrap);
            });
            imageHtmlWrap.insertBefore($('.step2 .product_description'));
            initStep2ImageSlides(imageHtmlWrap);
            $.get('/products/' + product.handle + '?view=metafields', function(response) {
               var data = JSON.parse(response);
               $('<h4>' + data.metafields.title + '</h4>').appendTo($('.step2 .description'));
               $('<div class = "details">' + data.metafields.description + '</div>').appendTo($('.step2 .description'));
            });
            productSelectedStep2 = product;
            $([document.documentElement, document.body]).animate({
               scrollTop: $(".step2 > .step-title").offset().top - 30
            }, 500);
         }

         function getTags(productTags) {
            var html = '';
            productTags.forEach(function(prodTag) {
               if (tagCond.indexOf(prodTag) != -1) {
                  if (html == '') {
                     html += prodTag;
                  } else {
                     html += ',' + prodTag; 
                  }
               }
            });
            return html;
         }

         function showStep2(products) {
            products.forEach(function(prod) {
               var itemHtml = $('<li data-handle="' + prod.handle + '"><div class="image-color"><a><img  src="' + prod.images[1] + '"/></a></div><div class="prod-tag">' + getTags(prod.tags) + '</div><div class="title-color"><a>' + prod.title + '</a></div></li>');
               itemHtml.click(function() {
                  $('.step2 ul.list-item-color li').removeClass('selected');
                  $(this).addClass('selected');
                  showStep2ItemDetails(prod);
               })
               $('.step2 ul.list-item-color').append(itemHtml);
               var cw = itemHtml.find('.image-color').width();
               itemHtml.find('.image-color').css({'height':cw+'px'});
            });
         }

         $('.btn-next-2').click(function() {
            showStep3();
         });

         function showStep3() {
            var product = productSelectedStep2;
            $('.step3 .step-title').addClass('current');
            $('.step2 .step-content').hide();
            $('.step3 .step-content').show();
            $('.step3 .list-items').html('');
            $('.step2 .step-title').addClass('passed').removeClass('current');
            $('.step2 .step-title').html('2.' + $('.step2 .product_description h4').html());
            var itemHtmlWrap = $('<ul class="list-length"></ul>');
            product.variants.forEach(function(variant) {
               var price = Intl.NumberFormat(Shopify.locale, {
                  style: 'currency', 
                  currency: Shopify.currency.active,
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2,
               }).format(variant.price/100);
               var comparePrice = '';
               if (variant.compare_at_price) {
                  comparePrice = Intl.NumberFormat(Shopify.locale, {
                     style: 'currency',
                     currency: Shopify.currency.active,
                  }).format(variant.compare_at_price/100);
               } 
               var disabled = !variant.available ? 'disabled' : 'enabled';
               var itemHtml = $('<li class="'+disabled+'" data-compareprice="'+comparePrice+'" data-price="' + price + '" data-id="' + variant.id + '" data-value="' + variant.option1 + '">' + variant.option1.replace(' inches', '"') + '</li>');
               itemHtml.appendTo(itemHtmlWrap);
               if (variant.available) {
                  itemHtml.click(function() {
                     updateKrana(variant.price);
                     $('.step3 .list-items li').removeClass('selected');
                     $(this).addClass('selected');
                     $('input[name="id"]').val($(this).attr('data-id'));
                     $('a.addtocart').attr('data-pricetext', $(this).attr('data-price') +'<span class="comparePrice">' + $(this).attr('data-compareprice') + '</span>' + ' - Add to cart').html($(this).attr('data-price') + '<span class="comparePrice">' + $(this).attr('data-compareprice') + '</span>' + ' - Add to cart').show();
                  });
               } 
            });
            itemHtmlWrap.appendTo($('.step3 .list-items'));
            itemHtmlWrap.find('li.enabled:first').trigger('click');
         }

         function updateKrana(price) {
            var kranaPrice = price / 4;
            var price = Intl.NumberFormat(Shopify.locale, {
                  style: 'currency',
                  currency: Shopify.currency.active,
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2,
               }).format(kranaPrice/100);
            $('.price-payment').html(price);
         }
      }
   }

   customElements.define('step-package', SectionStepPackage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["temp-clipin-all-color"]) return;
  try {
    
  class SectionProductGallery extends HTMLElement {
     constructor() {
         super();
         
         var $container = $(this);

         $container.find('.slider-for').slick({
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows: true,
             dots: false,
             fade: false,
             draggable: false,
             infinite: true,
             asNavFor: '.slider-nav'
         });
         $container.find('.slider-nav').slick({
             slidesToShow: 5,
             slidesToScroll: 5,
             asNavFor: '.slider-for',
             vertical: true,
             verticalSwiping: true,
             dots: false,
             arrows: false,
             infinite: true,
             focusOnSelect: true
         });
     }
  }
  customElements.define('product-gallery', SectionProductGallery);

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["temp-textured-clipin-all-color"]) return;
  try {
    
  class SectionProductGallery extends HTMLElement {
     constructor() {
         super();
         
         var $container = $(this);

         $container.find('.slider-for').slick({
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows: true,
             dots: false,
             fade: false,
             draggable: false,
             infinite: true,
             asNavFor: '.slider-nav'
         });
         $container.find('.slider-nav').slick({
             slidesToShow: 5,
             slidesToScroll: 5,
             asNavFor: '.slider-for',
             vertical: true,
             verticalSwiping: true,
             dots: false,
             arrows: false,
             infinite: true,
             focusOnSelect: true
         });
     }
  }
  customElements.define('product-gallery', SectionProductGallery);

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["temp-vf-pony-timer"]) return;
  try {
    
  class SectionProductGallery extends HTMLElement {
     constructor() {
         super();
         
         var $container = $(this);

         $container.find('.slider-for').slick({
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows: true,
             dots: false,
             fade: false,
             draggable: false,
             infinite: true,
             asNavFor: '.slider-nav'
         });
         $container.find('.slider-nav').slick({
             slidesToShow: 5,
             slidesToScroll: 5,
             asNavFor: '.slider-for',
             vertical: true,
             verticalSwiping: true,
             dots: false,
             arrows: false,
             infinite: true,
             focusOnSelect: true
         });
     }
  }
  customElements.define('product-gallery', SectionProductGallery);

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["temp-vf-wig-timer"]) return;
  try {
    
  class SectionProductGallery extends HTMLElement {
     constructor() {
         super();
         
         var $container = $(this);

         $container.find('.slider-for').slick({
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows: true,
             dots: false,
             fade: false,
             draggable: false,
             infinite: true,
             asNavFor: '.slider-nav'
         });
         $container.find('.slider-nav').slick({
             slidesToShow: 5,
             slidesToScroll: 5,
             asNavFor: '.slider-for',
             vertical: true,
             verticalSwiping: true,
             dots: false,
             arrows: false,
             infinite: true,
             focusOnSelect: true
         });
     }
  }
  customElements.define('product-gallery', SectionProductGallery);

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["temp-wig-timer-novid"]) return;
  try {
    
  class SectionProductGallery extends HTMLElement {
     constructor() {
         super();
         
         var $container = $(this);

         $container.find('.slider-for').slick({
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows: true,
             dots: false,
             fade: false,
             draggable: false,
             infinite: true,
             asNavFor: '.slider-nav'
         });
         $container.find('.slider-nav').slick({
             slidesToShow: 5,
             slidesToScroll: 5,
             asNavFor: '.slider-for',
             vertical: true,
             verticalSwiping: true,
             dots: false,
             arrows: false,
             infinite: true,
             focusOnSelect: true
         });
     }
  }
  customElements.define('product-gallery', SectionProductGallery);

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["temp-wig-timer-v2"]) return;
  try {
    
            const handleIntersection = (entries, observer) => {
              if (!entries[0].isIntersecting) return;
          
              observer.unobserve(productRecommendationsSection);
          
              const url = productRecommendationsSection.dataset.url;
          
              fetch(url)
                .then(response => response.text())
                .then(text => {
                  const html = document.createElement('div');
                  html.innerHTML = text;
                  const recommendations = html.querySelector('.product-recommendations');
          
                  if (recommendations && recommendations.innerHTML.trim().length) {
                    productRecommendationsSection.innerHTML = recommendations.innerHTML;
                  }
                })
                .catch(e => {
                  console.error(e);
                });
            };
          
            const productRecommendationsSection = document.querySelector('.product-recommendations');
            const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
          
            observer.observe(productRecommendationsSection);
    
  class SectionProductGallery extends HTMLElement {
     constructor() {
         super();
         
         var $container = $(this);

         $container.find('.slider-for').slick({
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows: true,
             dots: false,
             fade: false,
             draggable: false,
             infinite: true,
             asNavFor: '.slider-nav'
         });
         $container.find('.slider-nav').slick({
             slidesToShow: 5,
             slidesToScroll: 5,
             asNavFor: '.slider-for',
             vertical: true,
             verticalSwiping: true,
             dots: false,
             arrows: false,
             infinite: true,
             focusOnSelect: true
         });
     }
  }
  customElements.define('product-gallery', SectionProductGallery);

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["temp-wig-timer"]) return;
  try {
    
  class SectionProductGallery extends HTMLElement {
     constructor() {
         super();
         
         var $container = $(this);

         $container.find('.slider-for').slick({
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows: true,
             dots: false,
             fade: false,
             draggable: false,
             infinite: true,
             asNavFor: '.slider-nav'
         });
         $container.find('.slider-nav').slick({
             slidesToShow: 5,
             slidesToScroll: 5,
             asNavFor: '.slider-for',
             vertical: true,
             verticalSwiping: true,
             dots: false,
             arrows: false,
             infinite: true,
             focusOnSelect: true
         });
     }
  }
  customElements.define('product-gallery', SectionProductGallery);

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["temp-wig-v3"]) return;
  try {
    
  class SectionProductGallery extends HTMLElement {
     constructor() {
         super();
         
         var $container = $(this);

         $container.find('.slider-for').slick({
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows: true,
             dots: false,
             fade: false,
             draggable: false,
             infinite: true,
             asNavFor: '.slider-nav'
         });
         $container.find('.slider-nav').slick({
             slidesToShow: 5,
             slidesToScroll: 5,
             asNavFor: '.slider-for',
             vertical: true,
             verticalSwiping: true,
             dots: false,
             arrows: false,
             infinite: true,
             focusOnSelect: true
         });
     }
  }
  customElements.define('product-gallery', SectionProductGallery);

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-timer-atc"]) return;
  try {
    
  class SectionProductGallery extends HTMLElement {
     constructor() {
         super();
         
         var $container = $(this);

         $container.find('.slider-for').slick({
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows: true,
             dots: false,
             fade: false,
             draggable: false,
             infinite: true,
             asNavFor: '.slider-nav'
         });
         $container.find('.slider-nav').slick({
             slidesToShow: 5,
             slidesToScroll: 5,
             asNavFor: '.slider-for',
             vertical: true,
             verticalSwiping: true,
             dots: false,
             arrows: false,
             infinite: true,
             focusOnSelect: true
         });
     }
  }
  customElements.define('product-gallery', SectionProductGallery);

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
      })();
